const axios = require("axios");
const AWS = require('aws-sdk');


function filter_answered_question(data, question_ids) {
    const new_question_ids = [];
    for (let question_id of question_ids){
        if (data[question_id]['answered'] === 0){
            new_question_ids.push(question_id);
        }
    }
    return new_question_ids;
}


function chooseKfromArray(k, values) {          // k = number_of_questions,
                                                // values = all_question_ids
    const indexArray = [];
    for (let i = 0; i < values.length; i++) {
        indexArray.push(i);
    }

    indexArray.sort(function(){         // random sorting
        return 0.5 - Math.random();
    });

    let ret = [];

    if (k > values.length){     // 남은게 별로 없으면
        k = values.length;
    }

    for (let i = 0; i < k; i++) {       //
        let idx = indexArray[i];
        ret.push(values[idx]);
    }

    return ret;
}


async function parseQuestion(data, number_of_questions) {
    /* json data structure
        {question_id: {question: "~~~~~",
                       correct: "~~~~~",
                       answered: 0,
                       },
          question_id: {question: "~~~~~",
                       correct: "~~~~~",
                       answered: 0,
                       },
           ...
         }
     */

    let all_question_ids = Object.keys(data);      // question_ids
    all_question_ids = filter_answered_question(data, all_question_ids)

    let selected_question_ids;
    if (number_of_questions > 0){
        selected_question_ids = chooseKfromArray(number_of_questions, all_question_ids);
    }else{
        // Or we select all passages
        selected_question_ids=all_question_ids;
    }

    // Get (number_of_questions) random questions to show the user.
    let ret = [];
    for (let i = 0; i < selected_question_ids.length; i++) {
        let question_id = selected_question_ids[i];
        const question_info = data[question_id];
        question_info["question_id"] = question_id;     // question_info = {question: '~~',
                                                        //                  correct: '~~~',
                                                        //                  question_id: xxx}
        ret.push(question_info);
    }
    return ret;
}


async function fetchQuestions(number_of_questions, data_url) {
    try{
        let seed_url = data_url + '/creation_seeds.json'
        const data = await axios.get(seed_url)
            .then(res=>{
                return res.data
            }).catch(err=>{
                console.log(err)
            });
        return await parseQuestion(data, number_of_questions);            // return questions
    }catch (e) {
        console.log(e);
    }
}


async function writeToS3(answered, feedback) {
    // initial setting for pre-signed URL
    AWS.config.update({
        accessKeyId: 'yourID',
        secretAccessKey: 'yourSecretKey',
        region: 'us-east-1',
        signatureVersion: 'v4'
    })
    const s3 = new AWS.S3()

    const Bucket = 'creation-raw-data-storage'
    const seedKey = 'data/creation_seeds.json'
    const saveKey = 'data/answered.json'
    const feedbackKey = 'data/feedback.json'
    const signedUrlExpireSeconds = 60*5
    const seedGETParams = {
        Bucket: Bucket,
        Key: seedKey,
        Expires: signedUrlExpireSeconds,
    }
    const seedPUTParams = {
        Bucket: Bucket,
        Key: seedKey,
        Expires: signedUrlExpireSeconds,
        // ContentType: "application/json",
        ACL: 'public-read'
    }
    const saveGETParams = {
        Bucket: Bucket,
        Key: saveKey,
        Expires: signedUrlExpireSeconds,
    }
    const savePUTParams = {
        Bucket: Bucket,
        Key: saveKey,
        Expires: signedUrlExpireSeconds,
        // ContentType: "application/json",
        ACL: 'public-read'
    }
    if (Object.values(feedback)[0] !== ""){
        const feedbackGETParams = {
            Bucket: Bucket,
            Key: feedbackKey,
            Expires: signedUrlExpireSeconds,
        }
        const feedbackPUTParams = {
            Bucket: Bucket,
            Key: feedbackKey,
            Expires: signedUrlExpireSeconds,
            // ContentType: "application/json",
            ACL: 'public-read'
        }
        const feedback_GET_url = s3.getSignedUrl('getObject', feedbackGETParams)
        const feedback_PUT_url = s3.getSignedUrl('putObject', feedbackPUTParams)

        let workerId = Object.keys(feedback)[0]
        const save_feedback = await axios.get(feedback_GET_url)
        .then(function(res){
            let temp = res.data
            temp[workerId] = feedback[workerId]
            return temp;         // save_data = {'question_id': {'question': ~~~,
        }).catch(function (err){
            if (err.response.status === 404){
                console.log('Make initial feedback file to save.');
                return feedback;
            }
        });

        let options = {headers: {'Content-Type': 'application/json', 'x-amz-acl': 'public-read'}};
        await axios.put(feedback_PUT_url, JSON.stringify(save_feedback), options).then(function(){
            console.log("Save the worker's feedback to S3.")
        })
    }
    else{
        console.log("There is no feedback.")
    }

    const seed_GET_url = s3.getSignedUrl('getObject', seedGETParams)
    const seed_PUT_url = s3.getSignedUrl('putObject', seedPUTParams)
    // console.log("seed_GET_url: ",seed_GET_url)
    // console.log("seed_PUT_url: ", seed_PUT_url)

    const save_GET_url = s3.getSignedUrl('getObject', saveGETParams)
    const save_PUT_url = s3.getSignedUrl('putObject', savePUTParams)
    // console.log("save_GET_url: ", save_GET_url)
    // console.log("save_PUT_url: ", save_PUT_url)


    const whole_data = await axios.get(seed_GET_url).then(response_seed=>{
        return response_seed.data               // whole_data = {question_id: {question: "~~~~~",
                                                //                             correct: "~~~~~",
                                                //                             answered: 0             },
                                                //                   ... ,
                                                //              }
    });
    // console.log("whole_data", whole_data)


    const save_data = await axios.get(save_GET_url)
    .then(function(res){
        return res.data;         // save_data = {'question_id': {'question': ~~~,
    }).catch(function (err){
        if (err.response.status === 404){
            console.log('Make initial save file.');
            const options = {headers: {'Content-Type': 'application/json', 'x-amz-acl': 'public-read'}};
            let init = {};
            return axios.put(save_PUT_url, JSON.stringify(init), options).then(function(){
                return init
            })
        }
    });
    // console.log("save_data: ", save_data)

    // 저장할 데이터 가공
    let keys = Object.keys(answered);
    console.log("question_ids: ", keys)
    for (let qid of keys){
        // creation_seed.json 에서 더 이상 뽑히지 않게 1로 만들고,
        whole_data[qid]['answered'] = 1
        // save file 에 추가.
        save_data[qid] = answered[qid]
    }


    const options = {headers: {'Content-Type': 'application/json'}};
    await axios.put(seed_PUT_url, JSON.stringify(whole_data), options)
        .then(function(){
            console.log("Change the answered variable to '1' in creation seeds file.")
        })
    await axios.put(save_PUT_url, JSON.stringify(save_data), options)
        .then(function(){
            console.log("Complete to save the responses (not passed) to answered file.")
        })
}


module.exports = {
    chooseKfromArray,
    fetchQuestions,
    writeToS3,
};